import Service from "../../Services";

const GroupVisit = {
  namespaced: true,
  state: {
    form: {
      id: "",
      branch_id: "",
      title_en: "",
      title_th: "",
      description_en: "",
      description_th: "",
      detail_en: "",
      detail_th: "",
      message_en: "",
      message_th: "",
      contact_info: "",
      contact_email: "",
      slug_url: "",
      is_publish: true
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id: "",
        branch_id: "",
        title_en: "",
        title_th: "",
        description_en: "",
        description_th: "",
        detail_en: "",
        detail_th: "",
        message_en: "",
        message_th: "",
        contact_info: "",
        contact_email: "",
        slug_url: "",
        is_publish: true
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getGroupVisit({ commit }, {page,search,sort_date,sort_branch}) {
      return Service.GroupVisitAPI.getGroupVisit(page,search,sort_date,sort_branch);
    },
    // eslint-disable-next-line no-unused-vars
    showGroupVisit({ commit }, id) {
      return Service.GroupVisitAPI.showGroupVisit(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveGroupVisit({ commit }, { id, data }) {
      if (id) {
        return Service.GroupVisitAPI.updateGroupVisit(id, data);
      } else {
        return Service.GroupVisitAPI.createGroupVisit(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteGroupVisit({ commit }, id) {
      return Service.GroupVisitAPI.deleteGroupVisit(id);
    },
    setFormGroupVisit({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    }
  }
};
export default GroupVisit;
